import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _ToastContainer;

const _excluded = ["key", "onClose", "onRemoved"];
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ToastContainer from './ToastContainer';
import ToastContext from './ToastContext';
import Toast from './Toast';

const ToastProvider = _ref => {
  let {
    children,
    size,
    kind,
    delay
  } = _ref;
  const [toasts, setToasts] = useState([]);
  const savedKey = useRef(0);

  const closeToast = key => {
    setToasts(toasts => toasts.map(t => {
      if (t.key === key) {
        t.show = false;
      }

      return t;
    }));
  };

  const removeToast = key => {
    setToasts(toasts => toasts.filter(t => t.key !== key));
  };

  const createToast = _ref2 => {
    let {
      key: keyProps,
      onClose,
      onRemoved
    } = _ref2,
        restToast = _objectWithoutPropertiesLoose(_ref2, _excluded);

    const key = keyProps || savedKey.current++;

    const handleOnClose = event => {
      closeToast(key);
      if (onClose) onClose(event, key);
    };

    const handleOnRemoved = event => {
      removeToast(key);
      if (onRemoved) onRemoved(event, key);
    };

    return Object.assign({
      key,
      kind,
      delay,
      show: true
    }, restToast, {
      // putting here, allows users override previous props
      onRemoved: handleOnRemoved,
      onClose: handleOnClose
    });
  };

  const addToast = props => {
    const toast = createToast(props);
    setToasts(toasts => [...toasts, toast]);
  };

  const clean = () => setToasts([]);

  const toastContext = {
    addToast,
    removeToast,
    closeToast,
    clean,
    toasts
  };
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: toastContext
  }, children, _ToastContainer || (_ToastContainer = /*#__PURE__*/React.createElement(ToastContainer, null)));
};

ToastProvider.sizes = Toast.sizes;
ToastProvider.kinds = Toast.kinds;
ToastProvider.defaultProps = {
  delay: 7000,
  kind: Toast.kinds.default,
  children: null
};
process.env.NODE_ENV !== "production" ? ToastProvider.propTypes = {
  /**
   * Sets the number of milliseconds to wait before automatically calling the `onClose` function. `onClose` should be passed by props.
   * This behavior is disabled by default.
   */
  delay: PropTypes.number,

  /**
   * Sets the kind for styling.
   */
  kind: PropTypes.oneOf([Toast.kinds.default, Toast.kinds.primary, Toast.kinds.success, Toast.kinds.danger, Toast.kinds.warning, Toast.kinds.help]),

  /**
   * Sets the children.
   */
  children: PropTypes.node
} : void 0;
export default ToastProvider;